<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Administração'"></basic-toolbar>
          <v-card-text>

            <v-layout>
              <router-link to="/administrador" class="opcaoAdministrador">
                <a>Ativar ou desativar permissão de administrador</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/projetos-aguardando-aprovacao" class="opcaoAdministrador">
                <a>Aprovar, devolver para o coordenador ou inabilitar ações de extensão aguardando aprovação</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/projetos-concluir" class="opcaoAdministrador">
                <a>Concluir ou desfazer a finalização de ações de extensão aguardando relatório</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/relatorios-aguardando-aprovacao" class="opcaoAdministrador">
                <a>Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/projetos-vencidos" class="opcaoAdministrador">
                <a>Ações com mais de 6 meses em preenchimento incompleto</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/projetos-parceiros" class="opcaoAdministrador">
                <a>Lista de projetos que possuem parceiros</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/relatorios-de-gestao" class="opcaoAdministrador">
                <a>Gerar relatórios de gestão</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/nova-mensagem" class="opcaoAdministrador">
                <a>Alterar mensagem inicial</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/usuarios-proex" class="opcaoAdministrador">
                <a>Lista de Usuários-Proex</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/relatorio-seguro" class="opcaoAdministrador">
                <a>Relatório de seguro</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/reprovar-relatorios-suspensao-coordenador" class="opcaoAdministrador">
                <a>Reprovação de Relatório com Suspensão de Coordenador</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/registro-envio-relatorio" class="opcaoAdministrador">
                <a>Registro de Envio de Relatórios de Projeto</a>
              </router-link>
            </v-layout>

            <!--
            <v-layout>
              <router-link to="/bolsas" class="opcaoAdministrador">
                <a>Registro de bolsas para concessão no sistema</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/administracao/definir-periodo-frequencia" class="opcaoAdministrador">
                <a>Definir período para o registro de frequência</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="/alocar-bolsas-em-massa" class="opcaoAdministrador">
                <a>Alocar bolsas em massa</a>
              </router-link>
            </v-layout>
            -->

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      aprovacao: {
        dataAprovacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ProjetosAguardandoAprovacao'})
      },
      aprovarProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' })
        projetos.postAprovarProjeto(this.idProjeto, this.aprovacao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetosAguardandoAprovacao'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .opcaoAdministrador {
    font-size: 1.5em;
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// administracao.vue?0cfcf77a